/** Affiche le prix effectif d'un hit Algolia (promo prioritaire). */
export function formatSearchPrice(item) {
  const promo = Number(item?.promoPrice) || 0;
  const base = Number(item?.basePrice) || 0;
  const price = promo > 0 ? promo : base;
  if (!price) return '';
  return `${price.toLocaleString('fr-FR')} FCFA`;
}
